import React, { useEffect, useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import { Card, Col, Container, Row, CardBody, CardTitle, Label, Button, Form } from "reactstrap";
import './switch.css';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useLocation } from "react-router-dom"
import { getroledata } from "service/myapi"
import Swal from "sweetalert2";

const Managepermission = () => {

    const initialValues = {
        role: "",
    };
    const [formData, setFormData] = useState(initialValues);
    const [isChecked, setIsChecked] = useState({});
    const { state } = useLocation()
    const [options, setpermission] = useState([]);

    useEffect(() => {
        if (state) {
            setFormData((prev) => ({ ...prev, role: state }));
        }
    }, [state]);

    useEffect(() => {
        getallroles();
    }, []);

    const getallroles = async () => {
        try {
            const response = await getroledata(state);
            const permissions = response.data.role.permissions;
            const options = Object.keys(permissions);
            setpermission(permissions);
            initializeCheckedState(permissions);
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    const initializeCheckedState = (fetchedPermissions) => {
        const initialCheckedState = {};
        fetchedPermissions.forEach(permission => {
            initialCheckedState[permission.Label] = permission.value === true;
        });
        setIsChecked(initialCheckedState);
    };

    const handleChange = (event) => {
        const { id, checked } = event.target;
        setIsChecked(prevState => ({
            ...prevState,
            [id]: checked
        }));
    };

    const handleSubmit = async e => {
        e.preventDefault()
        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_MYAPI_URL}/updatepermission`,
            headers: {
                "Content-Type": "application/json",
            },
            data: { role: state, permissions: isChecked },
        }
        axios
            .request(config)
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Permission updated successfully',
                }).then(() => {
                });
            })
            .catch(error => {
                console.log(error?.response)
                Swal.fire({
                    icon: 'error',
                    title: 'errro!',
                    text: 'Something went wrong',
                })
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Utility" breadcrumbItem="Role Permission" />
                    <Row>
                        <Card>
                            <CardBody>
                                <CardTitle className="mb-4"></CardTitle>

                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col lg={4}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-login">User Type</Label>
                                                <select
                                                    id="userType"
                                                    className="form-control"
                                                    value={formData.role}
                                                    disabled
                                                    onChange={handleChange}
                                                >
                                                    <option defaultValue>{state}</option>
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {options.map((permission, index) => (
                                            <div key={index} className="col-md-4 mb-3">
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input myfm"
                                                        type="checkbox"
                                                        id={permission.Label}
                                                        checked={isChecked[permission.Label] || false}
                                                        onChange={handleChange}
                                                    />
                                                    <label className="form-check-label mytextbx" htmlFor={permission.Label}>
                                                        {permission.Label}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </Row>
                                    <Row></Row>
                                    <Row></Row>
                                    <div>
                                        <button type="submit" className="btn btn-success w-md mx-2">
                                            SAVE
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Managepermission
